import { useState } from 'react';
import { latestFeed } from '@/mocks/homeData';

export default function LatestFeed() {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? latestFeed : latestFeed.slice(0, 5);

  return (
    <section id="latest-feed" className="w-full">
      <div className="flex items-end justify-between border-b border-background-200 pb-5">
        <div>
          <p className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
            <i className="ri-flashlight-line text-sm"></i>
            LATEST
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            最新爆料
          </h2>
        </div>
        <span className="hidden font-label text-sm text-foreground-500 sm:block">
          共 {latestFeed.length} 条 · 按发布时间排列
        </span>
      </div>

      <ul className="divide-y divide-background-200">
        {visible.map((post) => (
          <li key={post.id} className="group py-5">
            <a href="#latest-feed" className="block cursor-pointer">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-100/80 px-2.5 py-0.5 font-label text-xs text-primary-800">
                  {post.tag}
                </span>
                {post.hot && (
                  <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs text-accent-800">
                    <i className="ri-fire-fill text-[11px]"></i>
                    热议中
                  </span>
                )}
                <span className="font-label text-xs text-foreground-500">{post.time}</span>
              </div>

              <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                {post.title}
              </h3>
              <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600">
                {post.summary}
              </p>

              <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-3-line text-sm"></i>
                  {post.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line text-sm"></i>
                  {post.comments} 条跟帖
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line text-sm"></i>
                  {post.views} 围观
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>

      <div className="mt-6">
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          {expanded ? '收起部分爆料' : `加载更多爆料（还有 ${latestFeed.length - visible.length} 条）`}
          <i className={expanded ? 'ri-arrow-up-line text-base' : 'ri-arrow-down-line text-base'}></i>
        </button>
      </div>
    </section>
  );
}